import { Box, Typography } from '@mui/material';
import appBattle from 'assets/images/app_battle.svg';
import React, { FC } from 'react';
import { useStyles } from './EmptyPlaceholder.styles';

interface EmptyPlaceholderProps {
  size?: number;
  text?: string;
}

export const EmptyPlaceholder: FC<EmptyPlaceholderProps> = ({ size = 150, text, children }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root} data-testid="empty-placeholder">
      <img src={appBattle} width={size} />
      {text && <Typography color="primary.light">{text}</Typography>}
      {children}
    </Box>
  );
};
